<div class="editor-container">
  <!-- .editor-container{
    display: flex;
    flex-direction: column;
  } -->
  <div class="label">
    <div class="label-group">
      <i class="feather" data-feather="info"></i>
      <strong>{{ 'ONLINE_POLICIES' | translate }}</strong>
    </div>
    <div class="label-edit">
      <div *ngIf="isTranslating" class="translation-inline">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Traducción...
      </div>
      <a class="edit-link" [hidden]="isEditingOnlinePolicy || isTranslating" (click)="switchEditingOnlinePolicy()">
        <i class="feather" data-feather="edit"></i>
      </a>
      <a class="primary-btn edit-link" *ngIf="isEditingOnlinePolicy && !isTranslating" (click)="saveOnlinePolicy()">{{ 'SAVE' | translate }}</a>
    </div>
  </div>

  <!-- Language Toggle -->
  <div class="language-toggle" role="tablist">
    <button type="button" class="language-toggle__button"
            [class.is-active]="selectedLanguage === 'es'"
            (click)="selectLanguage('es')">
      {{ 'SPANISH' | translate }}
    </button>
    <button type="button" class="language-toggle__button"
            [class.is-active]="selectedLanguage === 'en'"
            (click)="selectLanguage('en')">
      {{ 'ENGLISH' | translate }}
    </button>
  </div>

  <div class="terms-page-container">
    <div class="terms-container">
      <div class="page-card">
        <quill-editor class="terms-editor" [styles]="{
          borderRadius: '0 0 10px 10px',
          padding: '5px',
          marginBottom: '2vh',
          height: '350px'
        }"  id="termsAndConditions-edit" [modules]="modules" [(ngModel)]="currentContent"></quill-editor>
        <p class="helper-text" *ngIf="selectedLanguage === 'en' && !contentEN">
          {{ 'AUTO_TRANSLATE_HINT' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>

<div class="modal terms-confirm-modal" id="successOnlinePolicyModal" tabindex="-1">
  <div class="modal-dialog terms-modal-dialog" role="document">
    <div class="modal-content terms-modal-content">
      <div class="modal-body terms-modal-body">
        <h3 class="text-center">{{ 'SUCCESS' | translate }}</h3>
        <p class="text-center">{{ 'ONLINE_POLICIES_SAVED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal terms-confirm-modal fade" id="errorOnlinePolicyModal" tabindex="-1">
  <div class="modal-dialog terms-modal-dialog" role="document">
    <div class="modal-content terms-modal-content">
      <div class="modal-body terms-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}!</h3>
        <p class="text-center">{{ 'ERROR_SAVING_CHANGES' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
